import React, { useEffect, useRef, useState } from "react";
import ReactGA from 'react-ga4';
import LandingBanner from "../../components/LandingBanner/LandingBanner";
import Header from "../../layouts/Header/Header";
import Footer from "../../layouts/Footer/Footer";
import "../Landing/Landing.css";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import { useDispatch, useSelector } from "react-redux";
import { getAllProfilesByRoll } from "../../redux/actions/profile/searchRoll";
import { CampaignListByRoll } from "../../types/profile/CampaignListByRoll";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faPrint, faCopy, faCircleCheck, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import "../Landing/Landing.css";
import "./InternalLanding.css";
import Pagination from "../../components/common/Pagination/Pagination";
import parseStatus from "../../utils/parseStatus";
import { useNavigate } from "react-router-dom";
import { getProfileOverview } from "../../redux/actions/profile/profile";
import { ProfileOverviewState } from "../../redux/reducers/getProfile/getProfileOverviewReducer";
import { updateCampaignStatus } from "../../redux/actions/campaign/updateStatus";
import { EXTERNAL_IN_PROGRESS, EXTERNAL_SUBMITTED, INTERNAL_IN_PROGRESS, RESET_GET_PROFILE_OVERVIEW } from "../../redux/actionTypes/actionsTypes";
import { UpdateCampaignState } from "../../redux/reducers/getCampaign/updateCampaignStatusReducer";
import i18n from "../../i18n";
import { generatePDF } from "../../redux/actions/file/file";
import { FileState } from "../../redux/reducers/getFile/getFileReducer";
import { GeneratePDFPayload } from "../../types/pdf/GeneratePDFPayload";
import { setReadOnly } from "../../redux/actions/readOnly/readOnly";
import { ProfileDetailsState } from "../../redux/reducers/getProfile/getProfileDetailsReducer";
import { defaultNumberPerPage } from "../../assets/data/pagination/pagination";
import { excludeCampaignYears, isInternalPortalCampaignEligibleForImport, isProfileTypeImportEligible } from "../../utils/campaignList";
import AnchorAsButton from "../../components/common/AnchorAsButton/AnchorAsButton";
import Modal from "../../components/common/Modal/Modal";
import { Trans, useTranslation } from "react-i18next";
import Button from "../../components/common/Button/Button";
import { setSnapshotTypeDisplay } from "../../redux/actions/snapshot/snapshotType";
import { GroupCampaignsByYear } from "../../types/profile/GroupCampaignsByYear";
import { selectAuthValidateInternalToken, selectDocumentViewer, selectELSLookups, selectGetFile, selectMenu, selectProfileGetAllByRoll, selectProfileGetDetails, selectProfileGetOverview, selectUpdateCampaignStatus } from "../../redux/selectors/exportSelectorPaths";
import "../../components/common/ErrorMessages/ErrorMessages.css";
import { getElsLookups } from "../../redux/actions/lookups/lookups";
import { GetElsLookupsState } from "../../redux/reducers/getLookups/getElsLookupsReducer";
import { setActiveMenuItem } from "../../redux/actions/menu/menu";
import { initialMenuItem } from "../../redux/reducers/getMenu/getMenuReducer";
import trackCustomGA4Event from "../../utils/GA4EventHelpers/trackCustomGA4Event";
import reportMenuDuration from "../../utils/GA4EventHelpers/reportMenuDuration";
import { generateDocumentViewerLinkAddLog, resetGenerateDocumentViewerLinkAddLog } from "../../redux/actions/documentViewer/documentViewer";
import ToolTip from "../../components/common/ToolTip/ToolTip";
import { BaseAsyncReducerState } from "../../redux/types";

export default function InternalLanding(): JSX.Element {
  const { t } = useTranslation(['transition', 'landing'])
  const roll = sessionStorage.getItem("rollNumber") as string

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const lang = localStorage.getItem("prefLang") ?? "en"
  const validateInternalTokenStore = useSelector(selectAuthValidateInternalToken);
  const profileOverview: ProfileOverviewState = useSelector(selectProfileGetOverview);
  const profileDetails: ProfileDetailsState = useSelector(selectProfileGetDetails);
  const updateCampaignStatusState: UpdateCampaignState = useSelector(selectUpdateCampaignStatus);
  const fileState: FileState = useSelector(selectGetFile);
  const elsLookupsState: GetElsLookupsState = useSelector(selectELSLookups);
  const documentViewerState: BaseAsyncReducerState = useSelector(selectDocumentViewer);
  const getAllProfilesStore = useSelector(selectProfileGetAllByRoll);
  const menuState = useSelector(selectMenu);
  const [isRollSearchReqSent, setIsRollSearchReqSent] = useState(false);
  const [isStatusReqSent, setIsStatusReqSent] = useState(false);
  const [isProfileDetailsReqSent, setIsProfileDetailsReqSent] = useState(false)
  const [downloading, setDownloading] = useState(false);
  const [navigateToPortal, setNavigateToPortal] = useState(false);
  const [isProfileOverviewReqSent, setIsProfileOverviewReqSent] = useState(false);
  const [isLookupFetchReqSent, setIsLookupFetchReqSent] = useState(false);
  const [showImportQuestionModal, setShowImportQuestionModal] = useState(false);
  const [showErrorBlock, setShowErrorBlock] = useState(false);
  const [campaignList, setCampaignList] = useState<GroupCampaignsByYear[]>([])
  const [selectedCampaignYear, setSelectedCampaignYear] = useState(new Date().getFullYear());
  const [selectedCampaignId, setSelectedCampaignId] = useState("");
  const [selectedProfileId, setSelectedProfileId] = useState("");
  // Pagination related states and methods
  const [pageData, setPageData] = useState<GroupCampaignsByYear[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(defaultNumberPerPage);
  const documentViewerWindowRef = useRef<Window | null>(null);

  useEffect(() => {
    roll && dispatch(getAllProfilesByRoll(roll));
    setIsRollSearchReqSent(true);
    dispatch({ type: RESET_GET_PROFILE_OVERVIEW })
    dispatch(setSnapshotTypeDisplay(""))
    dispatch(setActiveMenuItem(initialMenuItem))
    reportMenuDuration(menuState, "Home");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isRollSearchReqSent && !getAllProfilesStore.loading) {
      if (getAllProfilesStore.found && getAllProfilesStore.grouped_campaigns) {
        const campaignList = getAllProfilesStore.grouped_campaigns.filter((campaign) => !excludeCampaignYears.includes(Number(campaign.year)))
        setCampaignList(campaignList)
      }
      else if (!getAllProfilesStore.found) {
        setShowErrorBlock(true);
      }
    }
  }, [isRollSearchReqSent, getAllProfilesStore]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    if (campaignList) {
      setPageData(campaignList.slice(itemOffset, endOffset));
      setTotalPages(Math.ceil(campaignList.length / itemsPerPage));
    }
  }, [campaignList, itemOffset, itemsPerPage]);


  const handleItemsPerPage = (itemCount: number) => {
    setItemsPerPage(itemCount);
  }

  const handlePageClick = ({ selected }: { selected: number }) => {
    if (pageData && campaignList) {
      const newOffset = (selected * itemsPerPage) % campaignList.length;
      setItemOffset(newOffset);
    }
  };

  useEffect(() => {
    if (!isProfileDetailsReqSent && !isProfileOverviewReqSent && !isLookupFetchReqSent && navigateToPortal) {
      navigate('/portal');
    }

  }, [navigate, navigateToPortal, isLookupFetchReqSent, isProfileOverviewReqSent, isProfileDetailsReqSent])

  useEffect(() => {
    if (isProfileOverviewReqSent) {
      if (profileOverview.error) {
        // clear local storage if load profile overview fails
        sessionStorage.removeItem("activeCampaignYear")
        sessionStorage.removeItem('campaignId')
        sessionStorage.removeItem('campaignStatusCode');
        sessionStorage.removeItem("currentSnapshotId");
        sessionStorage.removeItem("editMode");
        toast.error("Failed to load profile overview");
      }
      else {
        setIsProfileOverviewReqSent(false);
        setNavigateToPortal(true)
      }

    }
  }, [isProfileOverviewReqSent, profileOverview]);

  const startModifiedSubmission = (selectedProfileId: string, profileTypeCode: string, propertyCode: string, campaignId: string, selectedCampaignYear: string, statusCode: string, snapshots: Record<string, unknown>[] | undefined) => {
    setSelectedCampaignId(campaignId);
    setSelectedCampaignYear(Number(selectedCampaignYear));
    setSelectedProfileId(selectedProfileId)
    switch (statusCode) {
      case "NEW_CREATION": {
        sessionStorage.setItem("propertyCode", propertyCode);
        ReactGA.gtag("set", "user_properties", {
          property_code: propertyCode
        })
        setShowImportQuestionModal(true);
        dispatch(getProfileOverview(selectedProfileId))
        break;
      }
      case "EXTERNAL_IN_PROGRESS": { // Do not resend update status request, just continue with same status
        dispatch(setSnapshotTypeDisplay(getSnapshotTypeDisplay('2')))
        const type2snapshot = snapshots?.find(snapshot => snapshot['snapshotTypeCode'] === "2");
        type2snapshot && continueReturn(campaignId, selectedCampaignYear, statusCode, type2snapshot['snapshotId'] as string, selectedProfileId, propertyCode);
        break;
      }
      case "EXTERNAL_SUBMITTED": {
        sessionStorage.setItem("propertyCode", propertyCode)
        ReactGA.gtag("set", "user_properties", {
          property_code: propertyCode
        })
        dispatch(updateCampaignStatus(
          INTERNAL_IN_PROGRESS,
          selectedProfileId,
          profileTypeCode,
          campaignId,
          roll
        ));
        setIsStatusReqSent(true);
        break;
      }
      case "INTERNAL_IN_PROGRESS": { // Do not resend update status request, just continue with same status
        dispatch(setSnapshotTypeDisplay(getSnapshotTypeDisplay('3')))
        const type3snapshot = snapshots?.find(snapshot => snapshot['snapshotTypeCode'] === "3");
        type3snapshot && continueReturn(campaignId, selectedCampaignYear, statusCode, type3snapshot['snapshotId'] as string, selectedProfileId, propertyCode);
        break;
      }
      default:
        toast.error('Something went wrong. Please try again');
        break;
    }
  };

  const getSnapshotTypeDisplay = (snapshotType: string | undefined): string => {
    if (snapshotType === "2") {
      return " - Original"
    } else if (snapshotType === "3") {
      return " - Modified"
    } else {
      return ""
    }
  }

  const startReadOnlyMode = (year: string, currentSnapshotId: string, campaignId: string, snapshotType: string, profileId: string, propertyCode: string, statusCode: string) => {
    sessionStorage.setItem("activeCampaignYear", year);
    sessionStorage.setItem("currentSnapshotId", currentSnapshotId);
    sessionStorage.setItem("editMode", "true");
    sessionStorage.setItem("campaignId", campaignId);
    sessionStorage.setItem("profileId", profileId);
    sessionStorage.setItem("propertyCode", propertyCode);
    sessionStorage.setItem("campaignStatusCode", statusCode);

    ReactGA.gtag("set", "user_properties", {
      property_code: propertyCode
    })
    trackCustomGA4Event('view_submission', {
      is_current_year: (String(process.env.REACT_APP_ACTIVE_CAMPAIGN_YEAR) === year) ? "Current Submission" : "Previous Submission",
    })

    dispatch(setReadOnly(true))
    dispatch(setSnapshotTypeDisplay(getSnapshotTypeDisplay(snapshotType)));

    dispatch(getProfileOverview(profileId));
    setIsProfileOverviewReqSent(true);

    dispatch(getElsLookups(propertyCode));
    setIsLookupFetchReqSent(true);
  }

  const downloadSubmissionPDF = (campaignYear: number, campaignId: number, snapshotType: string, profileId: number) => {
    setSelectedCampaignYear(campaignYear);
    const payload: GeneratePDFPayload = {
      language: i18n.language,
      rollNumber: roll as string,
      profileId: profileId,
      campaignYear: campaignYear,
      campaignId: campaignId,
      snapshotRequestType: snapshotType,
      wac: sessionStorage.getItem("wac")
    }
    trackCustomGA4Event("download_submission", {
      is_current_year: (String(process.env.REACT_APP_ACTIVE_CAMPAIGN_YEAR) === String(campaignYear)) ? "Current Submission" : "Previous Submission",
    })
    dispatch(generatePDF(payload));
    setDownloading(true);
  };

  useEffect(() => {
    if (downloading && fileState.loading === false) {
      setDownloading(false);
      if (fileState.status === 200) {
        const url = fileState.s3url
        const downloadLink = document.createElement("a")
        downloadLink.href = url
        downloadLink.download = roll + "_" + selectedCampaignYear + "_AIRP.pdf";
        downloadLink.click();
      } else {
        toast.error(fileState.message);
      }
    }
  }, [downloading, fileState, selectedCampaignYear, roll]);

  useEffect(() => {
    if (isProfileDetailsReqSent) {
      if (!profileDetails.loading && profileDetails.success) {
        setIsProfileDetailsReqSent(false)
        setNavigateToPortal(true);
      }
      else {
        toast.error("Failed to load profile details");
      }
    }
  }, [isProfileDetailsReqSent, profileDetails]);

  useEffect(() => {
    if (isLookupFetchReqSent && !elsLookupsState.loading) {
      if (elsLookupsState.success && elsLookupsState.dropdowns) {
        setNavigateToPortal(true);
        setIsLookupFetchReqSent(false);
      }
      else {
        toast.error("Failed to retrieve lookups.")
      }
    }
  }, [isLookupFetchReqSent, elsLookupsState]);

  const continueReturn = (campaignId: string, year: string, statusCode: string, snapshotId: string, profileId: string, propertyCode: string) => {
    sessionStorage.setItem("activeCampaignYear", year)
    sessionStorage.setItem("campaignId", campaignId)
    sessionStorage.setItem("campaignStatusCode", statusCode);
    sessionStorage.setItem("currentSnapshotId", snapshotId);
    sessionStorage.setItem("profileId", profileId);
    sessionStorage.setItem("propertyCode", propertyCode);
    sessionStorage.setItem("editMode", "true");

    ReactGA.gtag("set", "user_properties", {
      property_code: propertyCode
    })

    dispatch(getProfileOverview(profileId));
    setIsProfileOverviewReqSent(true);

    dispatch(getElsLookups(propertyCode));
    setIsLookupFetchReqSent(true);
  }

  useEffect(() => {
    if (isStatusReqSent && !updateCampaignStatusState.loading && updateCampaignStatusState.updated) {
      const activeProfileID = updateCampaignStatusState.campaign["profileId"] as string;
      sessionStorage.setItem("activeCampaignYear", String(updateCampaignStatusState.campaign["campaignYear"]))
      sessionStorage.setItem("campaignId", String(updateCampaignStatusState.campaign["campaignId"]))
      sessionStorage.setItem("campaignStatusCode", updateCampaignStatusState.campaign["statusCode"] as string);
      sessionStorage.setItem("currentSnapshotId", updateCampaignStatusState.campaign["currentSnapshotId"] as string);
      sessionStorage.setItem("profileId", activeProfileID);
      sessionStorage.setItem("editMode", "true");

      dispatch(getProfileOverview(activeProfileID));
      setIsProfileOverviewReqSent(true);

      dispatch(setSnapshotTypeDisplay(getSnapshotTypeDisplay(updateCampaignStatusState.campaign["statusCode"] === "INTERNAL_IN_PROGRESS" ? "3" : "2")))

      dispatch(setReadOnly(false))
      setIsStatusReqSent(false);
    }
    else if (isStatusReqSent && updateCampaignStatusState.error) {
      toast.error("Failed to update status");
      setIsStatusReqSent(false);
    }
  }, [updateCampaignStatusState, isStatusReqSent, dispatch, navigate]);

  useEffect(() => {
    if (!documentViewerState.loading && documentViewerState.success && documentViewerWindowRef.current) {
      documentViewerWindowRef.current.location.href = (documentViewerState.data as Record<string, unknown>)["link"] as string;
      documentViewerWindowRef.current.document.title = (documentViewerState.data as Record<string, unknown>)["filename"] as string
      documentViewerWindowRef.current = null
      dispatch(resetGenerateDocumentViewerLinkAddLog())
    }
  }, [documentViewerState, dispatch])

  const getSnapshotByType = (campaign: CampaignListByRoll, type: string) => {
    const snapshots = campaign.snapshots

    if (!snapshots) {
      return undefined
    }

    return snapshots.find((s) => s["snapshotTypeCode"] === type)
  }

  const isCurrentStatus = (campaign: CampaignListByRoll, state: string[] | string) => {
    if (typeof state === "string") {
      return (campaign.statusCode as string) === state
    }

    return state.includes(campaign.statusCode as string)
  }

  const getLastModifiedBy = (campaign: CampaignListByRoll) => {
    let lastModifiedBy = "";
    const snapshotType3 = getSnapshotByType(campaign, '3');

    if (snapshotType3)
      lastModifiedBy = snapshotType3['lastUpdatedBy'] as string

    return lastModifiedBy
  }


  const viewPDF = (documentViewerFileName: null | string | undefined, documentViewerLink: string | null | undefined) => {
    if (documentViewerFileName && documentViewerLink) {
      // Modern browsers blocks new windows that are not triggered directly by an explicit user interaction
      const emptyDocumentViewWindow = window.open('about:blank', '_blank')
      if (emptyDocumentViewWindow) {
        emptyDocumentViewWindow.document.title = "Loading..."
        documentViewerWindowRef.current = emptyDocumentViewWindow
      }
      dispatch(generateDocumentViewerLinkAddLog({ path: documentViewerLink}))
    }
  }

  const getPassFailIndicator = (campaign: CampaignListByRoll) => {
    if (!isCurrentStatus(campaign, [EXTERNAL_SUBMITTED, INTERNAL_IN_PROGRESS]) || typeof campaign.passFailIndicator !== "boolean") {
      return null;
    }

    return campaign.passFailIndicator ?
      <FontAwesomeIcon icon={faCircleCheck} className="green-font internal-landing-pass-fail-icon" title="Pass" /> :
      <FontAwesomeIcon icon={faCircleExclamation} className="red-font internal-landing-pass-fail-icon" title="Fail" />;
  }

  return (<>
    <Header showAutoSave={false} isInternalUser={true} />
    <LandingBanner />
    <LoadingSpinner loading={validateInternalTokenStore.loading || profileOverview.loading || getAllProfilesStore.loading || elsLookupsState.loading}>
      <div className="landing-body-container">
        {showErrorBlock ?
          <div className="error-container internal-landing-error-container">
            <p>{getAllProfilesStore.unauthorized_access === true ? <Trans
              i18nKey="unauthorized-access"
              ns="landing"
              values={{ roll }}
            /> :
              <Trans
                i18nKey="contact-it-message"
                ns="landing"
                values={{ roll }}
              />}</p>
          </div>
          :
          <div className="landing-body landing-body-internal">
            <p className="select-text">{t("internal-landing-heading", { ns: "landing" })}</p>
            <LoadingSpinner loading={updateCampaignStatusState.loading || fileState.loading}>
              <div>
                <table className='internal-landing-table' cellSpacing="0" cellPadding="0">
                  <thead>
                    <tr className='internal-landing-table-heading-container'>
                      <th aria-label="Pass/Fail"></th>
                      <th>Roll number</th>
                      <th>Campaign Year</th>
                      <th>Status</th>
                      <th>Property Type</th>
                      <th>Profile Name</th>
                      <th>Profile Address</th>
                      <th>Edit</th>
                      <th>Original</th>
                      <th>Date Submitted</th>
                      <th>Submitted By</th>
                      <th>Modified</th>
                      <th>Last Modified By</th>
                      <th>Document Viewer</th>
                    </tr>
                  </thead>
                  {pageData && (pageData).map((group, index) => (
                    <tbody
                      className='internal-landing-table-body'
                      key={`${group.year}-${index}`}
                    >
                      {group.campaigns.map((campaign, campaignIndex) => (
                        <tr key={campaignIndex} className={index % 2 !== 0 ? "colored-bg-row" : ""}>
                          <td className="pass-fail-indicator-cell">{getPassFailIndicator(campaign)}</td>
                          <td>{roll}</td>
                          <td>{campaign.year}</td>
                          <td>
                            <span>
                              {parseStatus(campaign.statusCode as string)}
                            </span>
                          </td>
                          <td className="width-13-td">
                            <span>
                              {lang === "fr" ? campaign.propertyTypeNameFr : campaign.propertyTypeName}
                            </span>
                          </td>
                          <td className="width-13-td">{campaign.profileName}</td>
                          <td className="width-13-td">{campaign.profileAddress?.length as number > 260 ? campaign.profileAddress?.slice(0, 260) + "..." : campaign.profileAddress}</td>
                          <td className="action-icon-list">
                            {
                              <AnchorAsButton
                                onClick={() => {
                                  startModifiedSubmission(
                                    String(campaign.profileId),
                                    String(campaign.profileTypeCode),
                                    String(campaign.propertyCode),
                                    String(campaign.campaignId),
                                    String(campaign.year),
                                    campaign.statusCode as string,
                                    campaign.snapshots);
                                  dispatch(setReadOnly(false));
                                }}
                                ariaLabel={`edit ${roll}`}>
                                <FontAwesomeIcon icon={faPen} />
                              </AnchorAsButton>
                            }
                          </td>
                          <td className={'action-icon-list'}>
                            {getSnapshotByType(campaign, '2') ?
                              <>
                                {isCurrentStatus(campaign, ["EXTERNAL_IN_PROGRESS", "EXTERNAL_SUBMITTED", "INTERNAL_IN_PROGRESS"]) ?
                                  <AnchorAsButton
                                    onClick={() => {
                                      const snapshot = getSnapshotByType(campaign, '2')
                                      if (snapshot) {
                                        startReadOnlyMode(
                                          String(campaign.year),
                                          String(snapshot['snapshotId']),
                                          String(campaign.campaignId),
                                          '2',
                                          String(campaign.profileId),
                                          String(campaign.propertyCode),
                                          String(campaign.statusCode)
                                        );
                                        dispatch(setReadOnly(true));
                                      }
                                    }
                                    }
                                    ariaLabel={`view original ${roll}`}>
                                    <FontAwesomeIcon icon={faEye} />
                                  </AnchorAsButton> : <div className="blank-icon"></div>
                                }
                                {(isCurrentStatus(campaign, ["EXTERNAL_SUBMITTED", "INTERNAL_IN_PROGRESS", "EXTERNAL_IN_PROGRESS"])) ?
                                  <AnchorAsButton
                                    onClick={() =>
                                      downloadSubmissionPDF(campaign.year, campaign.campaignId, '2', campaign.profileId ?? 0)
                                    }
                                    ariaLabel={`download original submission pdf for ${roll}`}>
                                    <FontAwesomeIcon icon={faPrint} />
                                  </AnchorAsButton> : <div className="blank-icon"></div>
                                }
                              </> : <></>
                            }
                          </td>
                          <td className="no-wrap">{campaign.submittedDate}</td>
                          <td>{campaign.submittedBy}</td>
                          <td className={'action-icon-list'}>
                            {getSnapshotByType(campaign, '3') ?
                              <>
                                {isCurrentStatus(campaign, ["INTERNAL_IN_PROGRESS", "EXTERNAL_SUBMITTED"]) ?
                                  <AnchorAsButton
                                    onClick={() => {
                                      const snapshot = getSnapshotByType(campaign, '3')
                                      if (snapshot) {
                                        startReadOnlyMode(
                                          String(campaign.year),
                                          String(snapshot['snapshotId']),
                                          String(campaign.campaignId),
                                          '3',
                                          String(campaign.profileId),
                                          String(campaign.propertyCode),
                                          String(campaign.statusCode)
                                        );
                                        dispatch(setReadOnly(true));
                                      }
                                    }
                                    }
                                    ariaLabel={`view modified ${roll}`}>
                                    <FontAwesomeIcon icon={faEye} />
                                  </AnchorAsButton> : <div className="blank-icon"></div>
                                }
                                {(isCurrentStatus(campaign, ["EXTERNAL_SUBMITTED", "INTERNAL_IN_PROGRESS"])) ?
                                  <AnchorAsButton
                                    onClick={() =>
                                      downloadSubmissionPDF(campaign.year, campaign.campaignId, '3', campaign.profileId ?? 0)
                                    }
                                    ariaLabel={`download modified submission pdf for ${roll}`}>
                                    <FontAwesomeIcon icon={faPrint} />
                                  </AnchorAsButton> : <div className="blank-icon"></div>
                                }
                              </> : <></>
                            }
                          </td>
                          <td>
                            {getLastModifiedBy(campaign)}
                          </td>
                          <td>
                            {campaign.documentViewerLink && 
                              (campaign.documentViewerLink === "MULTIPLE" ? 
                                <ToolTip contents={<FontAwesomeIcon icon={faCopy} size="lg"/>}>Multiple documents found. Please go to Document Viewer to view each file.</ToolTip>
                                : <AnchorAsButton onClick={() => viewPDF(campaign.documentViewerFileName, campaign.documentViewerLink)} className="view-pdf-link">View PDF</AnchorAsButton>)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ))}
                </table>
                <Pagination
                  breakLabel='...'
                  nextLabel='Next'
                  previousLabel='Previous'
                  onPageChange={handlePageClick}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  setItemsPerPage={handleItemsPerPage} />
              </div>
            </LoadingSpinner>
          </div>}
      </div>
    </LoadingSpinner>
    {(showImportQuestionModal && profileOverview.found) && (
      <Modal onCloseModal={() => setShowImportQuestionModal(false)}>
        <p>
          {(isProfileTypeImportEligible(profileOverview.profile.profile_type_code) && isInternalPortalCampaignEligibleForImport(campaignList, selectedProfileId, selectedCampaignYear, true)) &&
            t('start.import-question')
          }
        </p>
        <div className="button-group justify-content-center">
          {(isProfileTypeImportEligible(profileOverview.profile.profile_type_code) && isInternalPortalCampaignEligibleForImport(campaignList, selectedProfileId, selectedCampaignYear, true)) ?
            <>
              <Button onClick={() => {
                trackCustomGA4Event(
                  "start_return_decision",
                  { start_decision: "import" }
                )
                dispatch(updateCampaignStatus(
                  EXTERNAL_IN_PROGRESS,
                  String(profileOverview.profile.profile_id),
                  profileOverview.profile.profile_type_code,
                  selectedCampaignId,
                  roll,
                  "true"));
                setIsStatusReqSent(true);
              }} type="submit" text={t("start.yes")} />
              <Button onClick={() => {
                trackCustomGA4Event(
                  "start_return_decision",
                  { start_decision: "new" }
                )
                dispatch(updateCampaignStatus(
                  EXTERNAL_IN_PROGRESS,
                  String(profileOverview.profile.profile_id),
                  profileOverview.profile.profile_type_code,
                  selectedCampaignId,
                  roll,
                  "false"));
                setIsStatusReqSent(true);
              }} type="secondary" text={t("start.no")} />
            </>
            :
            <Button onClick={() => {
              dispatch(updateCampaignStatus(
                EXTERNAL_IN_PROGRESS,
                String(profileOverview.profile.profile_id),
                profileOverview.profile.profile_type_code,
                selectedCampaignId,
                roll,
                "false"));
              setIsStatusReqSent(true);
            }} type="secondary" text={t("start.no-previous-campaigns")} />
          }
        </div>
      </Modal>
    )}
    <Footer />
  </>
  );
}
